import { render, staticRenderFns } from "./EditSongLyricsModal.vue?vue&type=template&id=b5e67078&scoped=true"
import script from "./EditSongLyricsModal.vue?vue&type=script&lang=ts"
export * from "./EditSongLyricsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e67078",
  null
  
)

export default component.exports